import React, { useState, useContext } from 'react';
import { Minus, Plus, Truck } from 'lucide-react';
import { Button } from '../ui/Button';
import { ProductAccordion } from './ProductAccordion';
import { CartContext } from '../../App';
export function ProductInfo() {
  const [size, setSize] = useState<string>('');
  const [color, setColor] = useState<string>('Black');
  const [quantity, setQuantity] = useState(1);
  const [sizeError, setSizeError] = useState(false);
  const {
    addToCart
  } = useContext(CartContext);
  const sizes = ['XS', 'S', 'M', 'L', 'XL'];
  const colors = [{
    name: 'Black',
    value: '#1A1A1A'
  }, {
    name: 'Gold',
    value: '#D4A853'
  }, {
    name: 'Cream',
    value: '#FDF9F3'
  }];
  const basePrice = 185;
  const productName = 'The Silk Wrap Dress';
  const handleQuantityChange = (delta: number) => {
    const newQty = quantity + delta;
    if (newQty >= 1 && newQty <= 10) {
      setQuantity(newQty);
    }
  };
  const handleSizeSelect = (s: string) => {
    setSize(s);
    setSizeError(false);
  };
  const handleAddToCart = () => {
    if (!size) {
      setSizeError(true);
      return;
    }
    setSizeError(false);
    addToCart({
      id: 1,
      name: productName,
      price: basePrice,
      size: size,
      color: color,
      quantity: quantity,
      image: 'bg-[#F5F5F5]'
    });
    setQuantity(1);
  };
  return <div className="flex flex-col" data-id="element-358">
      {/* Product Title & Price - Increased sizes */}
      <div className="mb-5 sm:mb-7" data-id="element-359">
        <h1 className="text-3xl sm:text-4xl md:text-5xl font-['Playfair_Display'] text-[#1A1A1A] leading-tight mb-3 sm:mb-4" data-id="element-360">
          {productName}
        </h1>
        <p className="text-2xl sm:text-3xl text-[#D4A853] font-medium font-['Raleway']" data-id="element-361">
          ${basePrice}.00
        </p>
      </div>

      {/* Description - Increased size */}
      <p className="text-[#6B6B6B] font-['Raleway'] leading-relaxed text-lg sm:text-xl mb-8 sm:mb-10" data-id="element-362">
        An elegant essential for your wardrobe. This wrap dress features a
        flattering V-neckline, adjustable waist tie, and flowing silhouette that
        moves beautifully with you.
      </p>

      <div className="space-y-6 sm:space-y-7 mb-8 sm:mb-10" data-id="element-363">
        {/* Color */}
        <div data-id="element-364">
          <p className="text-sm font-medium text-[#1A1A1A] uppercase tracking-[0.15em] mb-3 sm:mb-4" data-id="element-365">
            Color — <span className="text-[#6B6B6B] font-normal" data-id="element-366">{color}</span>
          </p>
          <div className="flex gap-4" data-id="element-367">
            {colors.map(c => <button key={c.name} type="button" onClick={() => setColor(c.name)} className={`w-9 h-9 sm:w-10 sm:h-10 rounded-full transition-all duration-200 ${color === c.name ? 'ring-2 ring-offset-[3px] ring-[#D4A853] ring-offset-[#FAFAFA]' : 'hover:scale-110'}`} style={{
            backgroundColor: c.value,
            boxShadow: c.name === 'Cream' ? 'inset 0 0 0 1px rgba(0,0,0,0.08)' : 'none'
          }} aria-label={c.name} data-id="element-368" />)}
          </div>
        </div>

        {/* Size */}
        <div data-id="element-369">
          <div className="flex justify-between items-baseline mb-3 sm:mb-4" data-id="element-370">
            <p className={`text-sm font-medium uppercase tracking-[0.15em] ${sizeError ? 'text-red-500' : 'text-[#1A1A1A]'}`} data-id="element-371">
              Size
              {size ? <span className="text-[#6B6B6B] font-normal" data-id="element-372"> — {size}</span> : sizeError ? <span className="font-normal" data-id="element-373"> — Please select</span> : null}
            </p>
            <button type="button" className="text-sm text-[#6B6B6B] hover:text-[#D4A853] transition-colors underline underline-offset-2" data-id="element-374">
              Size Guide
            </button>
          </div>
          <div className="flex flex-wrap gap-3" data-id="element-375">
            {sizes.map(s => <button key={s} type="button" onClick={() => handleSizeSelect(s)} className={`w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center text-base font-medium transition-all duration-200 ${size === s ? 'bg-[#1A1A1A] text-white' : sizeError ? 'bg-transparent text-[#1A1A1A] border border-red-300 hover:border-red-400' : 'bg-transparent text-[#1A1A1A] border border-[#E8E8E8] hover:border-[#1A1A1A]'}`} data-id="element-376">
                {s}
              </button>)}
          </div>
          {sizeError && <p className="text-sm text-red-500 mt-3 font-['Raleway']" data-id="element-377">
              Please select a size to continue
            </p>}
        </div>

        {/* Quantity */}
        <div data-id="element-378">
          <p className="text-sm font-medium text-[#1A1A1A] uppercase tracking-[0.15em] mb-3 sm:mb-4" data-id="element-379">
            Quantity
          </p>
          <div className="inline-flex items-center border border-[#E8E8E8] h-12 sm:h-14" data-id="element-380">
            <button type="button" onClick={() => handleQuantityChange(-1)} className="w-12 sm:w-14 h-full flex items-center justify-center text-[#6B6B6B] hover:text-[#1A1A1A] hover:bg-[#F5F5F5] transition-all disabled:opacity-30" disabled={quantity <= 1} aria-label="Decrease quantity" data-id="element-381">
              <Minus size={18} data-id="element-382" />
            </button>
            <span className="w-12 sm:w-14 text-center font-medium text-[#1A1A1A] text-lg" data-id="element-383">
              {quantity}
            </span>
            <button type="button" onClick={() => handleQuantityChange(1)} className="w-12 sm:w-14 h-full flex items-center justify-center text-[#6B6B6B] hover:text-[#1A1A1A] hover:bg-[#F5F5F5] transition-all" aria-label="Increase quantity" data-id="element-384">
              <Plus size={18} data-id="element-385" />
            </button>
          </div>
        </div>
      </div>

      <div className="space-y-4 sm:space-y-5 mb-10 sm:mb-12" data-id="element-386">
        <Button type="button" size="lg" variant="secondary" className="w-full h-14 sm:h-16 text-sm sm:text-base tracking-[0.2em] font-semibold" onClick={handleAddToCart} data-id="element-387">
          Add to Cart — ${(basePrice * quantity).toFixed(2)}
        </Button>

        <p className="flex items-center justify-center gap-2 text-base text-[#6B6B6B] font-['Raleway'] tracking-wide" data-id="element-388">
          <Truck size={18} strokeWidth={1.5} className="text-[#D4A853]" data-id="element-389" />
          Free shipping on orders over $75
        </p>
      </div>

      <ProductAccordion data-id="element-390" />
    </div>;
}